export default __webpack_public_path__ + "static/media/slide1.1e3d7152.png";